// 公共请求和与请求相关利用率高的工具
import environment from '../config/environment'
import {getTokenAPI, loginAPI, getAttentionAndComparisonAPI, removeContrastAPI, addContrastAPI, getCompanyIdAPI} from './api'
import qs from 'qs'
import CryptoJS from 'crypto-js'

// 常量
const API_CODE = environment.apiCode
const API_KEY = environment.apiKey
// const SIGN = environment.sign

// 加密
export function encrypt (param, code, sign) {
    code = CryptoJS.enc.Utf8.parse(CryptoJS.MD5(code).toString())
    sign = CryptoJS.enc.Utf8.parse(sign)
    let encrypted = CryptoJS.AES.encrypt(param, code, {
        iv: sign,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    })
    return encrypted.toString()
}

// 获取token
export function getToken () {
    const apiCode = 'code=' + API_CODE
    return getTokenAPI(apiCode)
}

// 登录
export function login () {
    return loginAPI()
}

// 侧边栏关注和对比
export function getAttentionAndComparison () {
    return getAttentionAndComparisonAPI()
}

// 侧边栏对比删除
export function removeContrast (params) {
    return removeContrastAPI(params)
}
// 加入对比对比删除
export function addContrast (companyId) {
    // 传入公司id
    return addContrastAPI({company_id: companyId})
}

// 公司id获取名片
export function getCompanyId (paramCom) {
    // 传入公司id
    const param = JSON.stringify({
        companyId: paramCom.companyId
    })
    const params = qs.stringify({
        code: API_CODE,
        token: paramCom.token,
        param: encrypt(param, API_CODE, API_KEY)
    })
    return getCompanyIdAPI(params)
}



// WEBPACK FOOTER //
// ./src/request/common.js